export default __webpack_public_path__ + "static/media/hht2_Intonation_02.c855441c.png";